import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { displayedLinks, DisplayLink } from '../../utils/displayed-links';

@Component({
  selector: 'app-top-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './top-nav.component.html',
  styleUrl: './top-nav.component.scss',
})
export class TopNavComponent {
  @Input() authResolved = true;
  @Input() isAuthenticated = false;
  @Input() isAdmin = false;
  @Output() logout = new EventEmitter<void>();

  get links(): DisplayLink[] {
    return displayedLinks.filter((l) => {
      if (l.requiresAdmin && !this.isAdmin) return false;
      if (l.requiresAuth && !this.isAuthenticated) return false;
      if (l.requiresUnauth && this.isAuthenticated) return false;
      return true;
    });
  }
}
